import { PolluxGridConfig } from "../../../../../components/common/pollux-grid-config/pollux-grid-config";

export const leasesGridColumns: PolluxGridConfig[] = [

  {
    field: "checkbox",
    type: "checkbox",
    width: 40
  },
  {
    title: 'comparablesLease.PrimaryUse',
    field: "PrimaryUse",
    width: 200
  },
  {
    title: 'comparablesLease.Sector',
    field: "Sector",
    width: 200
  },
  {
    title: 'comparablesLease.country',
    field: "countryDescription",
    width: 200
  },
  {
    title: 'comparablesLease.province',
    field: "Region",
    width: 200
  },
  {
    title: 'comparablesLease.city',
    field: "City",
    width: 200
  },
  {
    title: 'comparablesLease.subLocation',
    field: "SubLocationDescription",
    width: 200
  },
  {
    title: 'comparablesLease.zipCode6',
    field: "ZipCode6",
    width: 200
  },
  {
    title: 'comparablesLease.streetName',
    field: "StreetName",
    width: 200
  },
  {
    title: 'comparablesLease.numberFrom',
    field: "NumberFrom",
    width: 200
  },
  {
    title: 'comparablesLease.numberTo',
    field: "NumberTo",
    width: 200
  },
  {
    title: 'comparablesLease.numberAdd',
    field: "NumberAdd",
    width: 200
  },
  {
    title: 'comparablesLease.buildingName',
    field: "BuildingName",
    width: 200
  },
  {
    title: 'comparablesLease.propertyType',
    field: "propertyTypeDescription",
    width: 200
  },
  {
    title: 'comparablesLease.tenant',
    field: "Tenant",
    width: 200
  },
  {
    title: 'comparablesLease.contractStart',
    field: "ContractStart",
    type: 'date',
    width: 200
  },
  {
    title: 'comparablesLease.contractEnd',
    field: "ContractEnd",
    type: 'date',
    width: 200
  },
  {
    title: 'comparablesLease.lastRenovation',
    field: "lastRenovation",
    width: 200,
    type: 'year'
  },
  {
    title: 'comparablesLease.energyLabel',
    field: "EnergyLabelDescription",
    width: 200
  },
  {
    title: 'comparablesLease.propertyId',
    field: "PropertyIdDescription",
    width: 200
  },
  {
    title: 'comparablesLease.TenantFileRefNo',
    field: "TenantFileRefNo",
    width: 200
  },
  {
    title: 'comparablesLease.LeaseName',
    field: "LeaseName",
    width: 200
  },
  {
    title: 'comparablesLease.LeaseType',
    field: "LeaseType",
    width: 200
  },
  {
    title: 'comparablesLease.UnitDescription',
    field: "UnitDescription",
    width: 200
  },
  {
    title: 'comparablesLease.Covenant',
    field: "Covenant",
    width: 200
  },
  {
    title: 'comparablesLease.Status',
    field: "Status",
    width: 200
  },
  {
    title: 'comparablesLease.TenantUse',
    field: "TenantUse",
    width: 200
  },
  {
    title: 'comparablesLease.DeemedRent',
    field: "DeemedRent",
    type: 'currency',
    width: 200
  },
  {
    title: 'comparablesLease.GroundRent',
    field: "GroundRent",
    type: 'currency',
    width: 200
  },
  {
    title: 'comparablesLease.CostDeductions',
    field: "CostDeductions",
    type: 'number2',
    width: 200
  },
  {
    title: 'comparablesLease.RentalValue',
    field: "RentalValue",
    type: 'currency',
    width: 200
  },
  {
    title: 'comparablesLease.ErvRatePerSqft',
    field: "ErvRatePerSqft",
    type: 'currencyPerArea',
    width: 200
  },
  {
    title: 'comparablesLease.RentRatePerSqft',
    field: "RentRatePerSqft",
    type: 'currencyPerArea',
    width: 200
  },
  {
    title: 'comparablesLease.PercentErv',
    field: "PercentErv",
    type: 'number2',
    width: 200
  },
  {
    title: 'comparablesLease.PercentRent',
    field: "PercentRent",
    type: 'number2',
    width: 200
  },
  {
    title: 'comparablesLease.AreaSqft',
    field: "AreaSqft",
    type: 'area',
    width: 200
  },
  {
    title: 'comparablesLease.Froth',
    field: "Froth",
    type: 'number2',
    width: 200
  },
  {
    title: 'comparablesLease.PercentFroth',
    field: "PercentFroth",
    type: 'number2',
    width: 200
  },
  {
    title: 'comparablesLease.ErvUplift',
    field: "ErvUplift",
    type: 'number2',
    width: 200
  },
  {
    title: 'comparablesLease.PercentErvUpliftPerRent',
    field: "PercentErvUpliftPerRent",
    type: 'number2',
    width: 200
  },
  {
    title: 'comparablesLease.PercentErvUpliftPerTotalRent',
    field: "PercentErvUpliftPerTotalRent",
    type: 'number2',
    width: 200
  },
  {
    title: 'comparablesLease.NextReview',
    field: "NextReview",
    type: 'date',
    width: 200
  },
  {
    title: 'comparablesLease.LeaseStart',
    field: "LeaseStart",
    type: 'date',
    width: 200
  },
  {
    title: 'comparablesLease.LeaseExpiry',
    field: "LeaseExpiry",
    type: 'date',
    width: 200
  },
  {
    title: 'comparablesLease.PeriodToExpiry',
    field: "PeriodToExpiry",
    type: 'number2',
    width: 200
  },
  {
    title: 'comparablesLease.EffectiveBreak',
    field: "EffectiveBreak",
    type: 'date',
    width: 200
  },
  {
    title: 'comparablesLease.BreakType',
    field: "BreakType",
    width: 200
  },
  {
    title: 'comparablesLease.PeriodToBreak',
    field: "PeriodToBreak",
    type: 'number2',
    width: 200
  },
  {
    title: 'comparablesLease.EarliestTermination',
    field: "EarliestTermination",
    type: 'date',
    width: 200
  },
  {
    title: 'comparablesLease.PeriodToTermination',
    field: "PeriodToTermination",
    type: 'number2',
    width: 200
  },
  {
    title: 'comparablesLease.VoidExpiryByBreak',
    field: "VoidExpiryByBreak",
    type: 'number2',
    width: 200
  },
  {
    title: 'comparablesLease.VacantPeriod',
    field: "VacantPeriod",
    type: 'number2',
    width: 200
  },
  {
    title: 'comparablesLease.GrossValue',
    field: "GrossValue",
    type: 'currency',
    width: 200
  },
  {
    title: 'comparablesLease.ErvVacancyLoss',
    field: "ErvVacancyLoss",
    type: 'number2',
    width: 200
  },
  {
    title: 'comparablesLease.PercentErvVacancyLoss',
    field: "PercentErvVacancyLoss",
    type: 'number2',
    width: 200
  },
  {
    title: 'comparablesLease.ErvVoidLoss',
    field: "ErvVoidLoss",
    type: 'number2',
    width: 200
  },
  {
    title: 'comparablesLease.CapitalisationGroup',
    field: "CapitalisationGroup",
    width: 200
  },
  {
    title: 'comparablesLease.ValuationMethod',
    field: "ValuationMethod",
    width: 200
  },
  {
    title: 'comparablesLease.HardcoreYield',
    field: "HardcoreYield",
    type: 'number2',
    width: 200
  },
  {
    title: 'comparablesLease.ReversionYield',
    field: "ReversionYield",
    type: 'number2',
    width: 200
  },
  {
    title: 'comparablesLease.FrothYield',
    field: "FrothYield",
    type: 'number2',
    width: 200
  },
  {
    title: 'comparablesLease.DcfExitYld',
    field: "DcfExitYld",
    type: 'number2',
    width: 200
  },
  {
    title: 'comparablesLease.RentFreePeriod',
    field: "RentFreePeriod",
    type: 'number2',
    width: 200
  },
  {
    title: 'comparablesLease.ContractedRent',
    field: "ContractedRent",
    type: 'currency',
    width: 200
  },
  {
    title: 'projectstd.currency',
    field: "currencyDescription",
    width: 200
  },
  {
    title: 'projectstd.unitOfLength',
    field: "unitOfLengthDescription",
    width: 200
  },
  {
    title: 'comparablesLease.oid',
    field: "oid",
    width: 200
  },
  {
    title: 'comparablesLease.ownerUserID',
    field: "OwnerUserIDDescription",
    width: 200
  },
  {
    title: 'comparablesLease.createdDate',
    field: "CreatedDate",
    type: 'date',
    width: 200
  },
  {
    title: 'comparablesLease.ownerBuID',
    field: "OwnerBuIDDescription",
    width: 200
  },
  {
    title: 'comparablesLease.modifiedDate',
    field: "ModifiedDate",
    type: 'date',
    width: 200
  },
  {
    title: 'comparablesLease.modifiedByUserId',
    field: "ModifiedByUserIdDescription",
    width: 200
  },
  {
    title: 'comparablesLease.modifiedBuID',
    field: "ModifiedBuIDDescription",
    width: 200
  }
];
